var map = {
  "./en.json": "52196",
  "./fr-CA.json": "2502",
  "./sv.json": "60054",
  "./hu.json": "43140",
  "./ja.json": "41522",
  "./nl.json": "29357",
  "./de.json": "99160",
  "./es-419.json": "21432",
  "./es.json": "11107",
  "./fr.json": "80063",
  "./it.json": "78474",
  "./pt.json": "60991"
};
function __rspack_async_context(req) {
  return Promise.resolve().then(function() {
if(!__webpack_require__.o(map, req)) {
  var e = new Error("Cannot find module '" + req + "'");
  e.code = 'MODULE_NOT_FOUND';
  throw e;
}

var id = map[req];
return __webpack_require__.t(id, 1 | 16);
});
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 21193;
module.exports = __rspack_async_context;
